/* FINECT JB20: route-local, cached, lazy-loaded library and engine. */
(function(){
  'use strict';
  function placeCard(){
    var card=document.querySelector('[data-jb20-card]');
    if(!card)return;
    var mobile=matchMedia('(max-width:576px)').matches;
    var slot=document.querySelector(mobile?'[data-jb20-card-mobile]':'[data-jb20-card-desktop]');
    if(slot && card.parentNode!==slot)slot.appendChild(card);
  }
  placeCard();
  var mq=matchMedia('(max-width:576px)');
  if(mq.addEventListener)mq.addEventListener('change',placeCard);
  function load(url){return new Promise(function(resolve,reject){var s=document.createElement('script');s.src=url;s.onload=resolve;s.onerror=reject;document.head.appendChild(s);});}
  var config=document.querySelector('[data-jb20-assets]');
  if(!config)return;
  function boot(){
    if(window.FINECT_JB20_LOADING)return;
    window.FINECT_JB20_LOADING=true;
    load(config.dataset.three).then(function(){return load(config.dataset.engine);}).catch(function(){
      document.querySelectorAll('.jb20-fp').forEach(function(root){root.classList.add('is-nogl');});
    });
  }
  if(!window.IntersectionObserver){boot();return;}
  var io=new IntersectionObserver(function(entries){if(entries.some(function(e){return e.isIntersecting;})){io.disconnect();boot();}},{rootMargin:'400px 0px'});
  document.querySelectorAll('.jb20-fp').forEach(function(root){io.observe(root);});
})();
